import React from "react";
import "./Boiler.css";
import ashchain from "./image/Ash-Handling-Chain.jpg";
import dragchain from "./image/Drag-chain.jpg";
import gatechain from "./image/Gate-chain.jpg";
import travellingchain from "./image/Travelling-Grate-Chain.jpg";

const Boiler = () => {
  return (
    <div>
      <div className="boilerp">
        <p className="p">Boiler And Thermal Power Plant</p>
        <div className="p2">
          {/* <p>Swajit Engineering Pvt.Ltd: &gt; Products &gt; Boiler And Thermal Power Plant</p> */}
        </div>
      </div>

      <div className="boiler">
        <div className="unimg">
          <figure>
            <img src={ashchain} alt="Ash Chain" />
            <figcaption>Range Attachment Ring</figcaption>
          </figure>
        </div>

        <div className="boimg">
          <figure>
            <img src={dragchain} alt="Drag Chain" />
            <figcaption>Range Forging Links</figcaption>
          </figure>
        </div>

        <div className="boimg">
          <figure>
            <img src={gatechain} alt="Gate Chain" />
            <figcaption>Range Ring</figcaption>
          </figure>
        </div>

        <div className="boimg">
          <figure>
            <img src={travellingchain} alt="Travelling Chain" />
            <figcaption>Range Ring</figcaption>
          </figure>
        </div>
      </div>
    </div>
  );
};

export default Boiler;
